import { effect, Injectable, signal } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/Auth/auth.service';

@Injectable({
    providedIn: 'root'
})
export class AdminGuard implements CanActivate {

    timeout: any
    isAdmin  : boolean = false
    

    constructor(
        private authService: AuthService,
        private router: Router
    ) { 
        // effect(() => {
        //     this.isAdmin = this.authService.isAdmin
        // })
    }


    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

        return new Promise((resolve) => {

            // effect(() => {
            // var x = this.authService.isEnabledSig()
            //     if (this.authService.isEnabledSig()) {
            //         this.router.navigate(['/login']);
            //         resolve(true)
            //     }
            //     else {
            //         resolve(false)

            //         this.timeout = setTimeout(() => {
            //             this.router.navigate(['/login']);
            //         }, 6000);
            //     }
            // })

            this.authService.isAdmin$.subscribe(res => {
                clearTimeout(this.timeout);
                if (res != null) {
                    // if (!res) {
                    var debugVal = this.authService.isEnabledSig()
                    if( !res && !this.router.url.includes('/dashboard')) {
                        this.router.navigate(['/']);
                    }
                    resolve(this.authService.isAdmin)
                }
                else {
                    this.timeout = setTimeout(() => {

                        this.router.navigate(['/']);
                    }, 6000);
                }
            })

        })
    }

}


// export const authGuard: CanActivateFn = (route, state) => {
//   return true;
// };
